import { pickBy, isNil } from "lodash"
import PropTypes from "prop-types"
import { FastForward, PlayArrow } from "@mui/icons-material"
import "./styles.scss"

/**
 * This method returns the drift description depending on which bucket the drift falls in:
 *  - very high: 95% - 100%
 *  - high: 75% - 95%
 *  - neutral: 25% - 75%
 *  - low: 5% - 25%
 *  - very low: 0% - 5%
 */
export default function Drift({ drift, x, y, viewBox }) {
  // allow for empty string in case we want to override default values
  const driftProps = pickBy({ x, y, viewBox }, value => !isNil(value))

  switch (true) {
    case !Number.isFinite(drift):
      return <div className="components_drift-icon" />
    case drift < -1.644854:
      return <FastForward className="components_drift-icon oversold-plus" {...driftProps} />
    case drift < -0.674490:
      return <PlayArrow className="components_drift-icon oversold" {...driftProps} />
    case drift < 0.674490:
      return <div className="components_drift-icon" />
    case drift < 1.644854:
      return <PlayArrow className="components_drift-icon overbought" {...driftProps} />
    default:
      return <FastForward className="components_drift-icon overbought-plus" {...driftProps} />
  }
}

Drift.propTypes = {
  drift: PropTypes.number.isRequired,
  x: PropTypes.number,
  y: PropTypes.number,
  viewBox: PropTypes.string,
}
